import React, { createContext, useContext, useEffect, useState } from "react";

import { useAuth } from "@/contexts/AuthContext";
import { UserTypeService, UserTypeState } from "@/services/core/UserTypeService";

interface UserTypeContextType {
  userTypeState: UserTypeState;
  isLoading: boolean;
}

const UserTypeContext = createContext<UserTypeContextType | undefined>(undefined);

export const UserTypeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const userTypeService = UserTypeService.getInstance();
  const [userTypeState, setUserTypeState] = useState<UserTypeState>(
    userTypeService.getUserTypeState(null),
  );

  useEffect(() => {
    const updateUserTypeState = async () => {
      setIsLoading(true);
      try {
        const state = userTypeService.getUserTypeState(user);
        setUserTypeState(state);
      } finally {
        setIsLoading(false);
      }
    };

    updateUserTypeState();
  }, [user, userTypeService]);

  return (
    <UserTypeContext.Provider value={{ userTypeState, isLoading }}>
      {children}
    </UserTypeContext.Provider>
  );
};

export const useUserType = () => {
  const context = useContext(UserTypeContext);
  if (context === undefined) {
    throw new Error("useUserType must be used within a UserTypeProvider");
  }
  return context;
};
